import { render, staticRenderFns } from "./stk_prdrtn.vue?vue&type=template&id=01b063b6&scoped=true&"
import script from "./stk_prdrtn.vue?vue&type=script&lang=js&"
export * from "./stk_prdrtn.vue?vue&type=script&lang=js&"
import style0 from "./stk_prdrtn.vue?vue&type=style&index=0&id=01b063b6&scoped=true&lang=less&"
import style1 from "./stk_prdrtn.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b063b6",
  null
  
)

export default component.exports